// src/pages/AlipayReturnPage.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AlipayReturnPage = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    //  从 URL 参数中获取更详细的支付结果信息
    const result = params.get('result') || 'unknown'; //  支付结果 (success, fail, unknown)
    const outTradeNo = params.get('out_trade_no');     //  你的订单号
    const tradeNo = params.get('trade_no');         //  支付宝交易号
    const totalAmount = params.get('total_amount');     //  支付金额
    const timestamp = params.get('timestamp');         //  同步返回时间
    const app_id = params.get('app_id');            //  支付宝应用 ID

    //  可以添加更多从 URL 参数中获取的信息，参考 Alipay 同步返回参数文档

    const isSuccess = result === 'success'; //  判断支付是否成功

    return (
        <div className="alipay-return-page" style={{ padding: '20px', textAlign: 'center' }}> {/* 添加基本样式 */}
            <h1 style={{ color: isSuccess ? 'green' : 'red' }}>
                支付宝支付{isSuccess ? '成功' : '结果'}
            </h1>

            {isSuccess ? (
                <div style={{ marginTop: '20px' }}>
                    <p style={{ color: 'green', fontWeight: 'bold' }}>恭喜您，支付已成功！</p>
                    <p>您的订单号: <strong>{outTradeNo}</strong></p>
                    <p>支付宝交易号: <strong>{tradeNo}</strong></p>
                    <p>支付金额: <strong>{totalAmount} 元</strong></p> {/*  显示支付金额 */}
                    <p>支付时间: <strong>{timestamp}</strong></p>      {/*  显示支付时间 */}
                    <p>支付宝应用 ID: <strong>{app_id}</strong></p>     {/*  显示支付宝应用 ID */}
                    {/*  可以添加更多需要显示的信息 */}
                </div>
            ) : (
                <div style={{ marginTop: '20px' }}>
                    <p style={{ color: 'red', fontWeight: 'bold' }}>支付{result === 'fail' ? '失败' : '结果未知'}</p>
                    <p>订单号: <strong>{outTradeNo || 'N/A'}</strong></p> {/*  订单号，如果存在 */}
                    <p>支付宝交易号: <strong>{tradeNo || 'N/A'}</strong></p> {/*  支付宝交易号，如果存在 */}
                    {/*  可以添加错误提示信息，或者引导用户重试支付 */}
                    {result === 'unknown' && (
                        <p style={{ color: 'orange' }}>
                            支付结果未知，请稍后 <Link to="/profile">查看订单详情</Link> 确认支付状态。
                        </p>
                    )}
                    {result === 'fail' && (
                        <p style={{ color: 'red' }}>
                            支付失败，请 <Link to="/payment">返回支付页面</Link> 重试，或 <Link to="/contact">联系客服</Link>。
                        </p>
                    )}
                </div>
            )}

            <div style={{ marginTop: '30px' }}>
                <Link to="/" style={{ margin: '0 10px' }}>返回首页</Link>
                <Link to="/profile" style={{ margin: '0 10px' }}>查看订单详情</Link> {/*  可以替换为订单详情页链接 */}
            </div>
        </div>
    );
};

export default AlipayReturnPage;